var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 48,
    r: 38,
    fill: "#73151F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.0072 67.422V49.7038H56.9547L57.8454 42.798H51.0072V38.3891C51.0072 36.3891 51.5618 35.0273 54.4294 35.0273L58.0863 35.0256V28.8487C57.4534 28.7651 55.2836 28.5767 52.7574 28.5767C47.4863 28.5767 43.8765 31.7944 43.8765 37.7047V42.7971H37.9138V49.7029H43.8765V67.4211H51.008L51.0072 67.422Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook1);
export default __webpack_public_path__ + "static/media/Facebook1.1f76933a8257446017bdc22e74dd5110.svg";
export { ForwardRef as ReactComponent };